"use client";

import { useState, useEffect, ReactNode } from 'react';
import type { Message } from 'ai';

// Lazy load the ChatWindow component
let ChatWindowComponent: any = null;

export interface ChatWindowWrapperProps {
  endpoint: string;
  emptyStateComponent: ReactNode;
  placeholder?: string;
  emoji?: string;
  showIngestForm?: boolean;
  showIntermediateStepsToggle?: boolean;
  initialMessages?: Message[];
  conversationId?: string;
  onConversationCreated?: (conversationId: string) => void;
  onMessageFinished?: () => void;
}

export function ChatWindowWrapper(props: ChatWindowWrapperProps) {
  const [isClient, setIsClient] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsClient(true);
    
    // Dynamically import the ChatWindow component
    import('./ChatWindow').then((module) => {
      ChatWindowComponent = module.ChatWindow;
      setIsLoading(false);
    }).catch((error) => {
      console.error('Failed to load ChatWindow:', error);
      setIsLoading(false);
    });
  }, []);

  if (!isClient || isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-sm text-muted-foreground">Loading chat...</p>
        </div>
      </div>
    );
  }

  if (!ChatWindowComponent) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <p className="text-sm text-red-500">Failed to load chat component</p>
        </div>
      </div>
    );
  }

  return <ChatWindowComponent {...props} />;
} 